import { Award, Clock, Heart, Sparkles, Shield, Wrench, DollarSign, HeartPulse } from "lucide-react";

const benefits = [
  { icon: Award, title: "Veteran Owned & Operated", description: "As a veteran-owned company, we bring military discipline and attention to detail to every project." },
  { icon: Clock, title: "10 Years Firefighter Experience", description: "Hard work, discipline, and meticulous attention to detail are the foundation of every project we undertake." },
  { icon: Heart, title: "Family Values", description: "As a family man, I understand the importance of making sure your home or business is well taken care of." },
  { icon: Sparkles, title: "Deep Cleaning Power", description: "Effectively remove dirt, grime, mold, mildew, and tough stains for a fresh, clean look." },
  { icon: Shield, title: "Enhances Curb Appeal", description: "Restore your property's appearance, making it more attractive to visitors, buyers, or customers." },
  { icon: Wrench, title: "Prevents Long-Term Damage", description: "Regular washing prevents buildup that causes damage to siding, decks, driveways, and fences." },
  { icon: DollarSign, title: "Time & Cost Effective", description: "Quick, efficient cleaning saves time compared to manual scrubbing. Reduces need for costly repairs." },
  { icon: HeartPulse, title: "Health & Safety", description: "Eliminates allergens, bacteria, and harmful substances for a healthier, safer environment." },
];

const WhyChooseSection = () => {
  return (
    <section className="section-padding bg-gradient-to-br from-primary via-primary to-accent relative overflow-hidden">
      <div className="container-custom relative z-10">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold font-heading text-white mb-4">
            WHY <span className="text-secondary">STREAM MASTERS</span>?
          </h2>
          <p className="text-lg text-white">
            Built on values of service, discipline, and excellence
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {benefits.map((benefit, index) => (
            <div key={index} className="bg-white/95 backdrop-blur-sm rounded-xl p-6 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-1">
              <div className="bg-primary/10 w-14 h-14 rounded-full flex items-center justify-center mb-4">
                <benefit.icon className="w-7 h-7 text-primary" />
              </div>
              <h3 className="text-lg font-bold font-heading text-secondary mb-2">{benefit.title}</h3>
              <p className="text-muted-foreground text-sm">{benefit.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseSection;